// src/forward.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var ForwardIcon = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "aria-hidden": "true",
    fill: "none",
    focusable: "false",
    height: "1em",
    role: "presentation",
    shapeRendering: "geometricPrecision",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    viewBox: "0 0 24 24",
    width: "1em",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M13 17l5-5-5-5" }),
      /* @__PURE__ */ jsx("path", { d: "M6 17l5-5-5-5" })
    ]
  }
);

export {
  ForwardIcon
};
